import React from "react";
import AccordionReferralCard from "components/card/AccordionReferralCard";
import FileRow from "components/file-components/file-row";
import { EntityType, Referral, ReferralEvidence } from "types";

interface EvidenceCardProps {
  referralData?: Referral | null;
  referralId?: string;
  handleButtonClick: (type: EntityType) => void;
  handleEdit: (type: EntityType, evidence: ReferralEvidence) => void;
  fileRowProps: any;
}

export default function EvidenceCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  fileRowProps,
}: EvidenceCardProps) {
  return (
    <AccordionReferralCard
      title={`Evidences - ${referralData?.evidences?.length || 0}`}
      buttonText="Add Evidence"
      onButtonClick={() => handleButtonClick("evidence")}
      disabled={
        !referralData ||
        [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.evidences && referralData.evidences.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.evidences.map((evidence) => (
            <div
              key={evidence.id}
              className="border rounded-lg p-4 bg-white shadow-sm"
            >
              <div className="flex items-center justify-between mb-3">
                <div>
                  <h4 className="font-semibold text-gray-800">
                    {evidence.evidence_type}
                  </h4>
                  <p className="text-sm text-gray-600">
                    {evidence.description}
                  </p>
                  {evidence.date && (
                    <p className="text-xs text-gray-500">
                      Date: {evidence.date}
                    </p>
                  )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleEdit("evidence", evidence)}
                    className="text-black hover:text-gray-800 transition"
                    disabled={
                      ![
                        "Investigation Ongoing",
                        "Pending",
                        "Prohibition On Revision",
                      ].includes(referralData?.action_status as string)
                    }
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {evidence.evidence_file_details &&
                evidence.evidence_file_details.length > 0 && (
                  <div className="mt-3">
                    <div className="space-y-2">
                      {evidence.evidence_file_details.map(
                        (file: any, index: number) => (
                          <FileRow
                            key={file.document_uuid || index}
                            file={file}
                            {...fileRowProps}
                          />
                        )
                      )}
                    </div>
                  </div>
                )}
            </div>
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No evidence added yet
        </div>
      )}
    </AccordionReferralCard>
  );
}
